<template>
    <div v-if="open">


        <div class="row">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="types_plotter_cutting">{{
                            trans.get('admin.pages.tasks..form.types_plotter_cutting.title')
                        }}</label>
                    <div class="col-sm-9">
                        <b-form-select
                            ref="types_plotter_cutting"
                            v-model="form.types_plotter_cutting"
                            :options="options.types_plotter_cutting"
                            text-field="name"
                            value-field="value"
                            @change="priceСalculation()"
                        ></b-form-select>
                    </div>
                </div>
            </div>

        </div>

        <div class="row" v-if="form.types_plotter_cutting != 0">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="sizex">{{
                            trans.get('admin.pages.tasks..form.size.title')
                        }}</label>
                    <div class="col-sm-9">
                        <b-form-input
                            ref="size"
                            v-model="form.size[0]"
                            max="310"
                            @change="priceСalculation()"
                        ></b-form-input>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="sizey"></label>
                    <div class="col-sm-9">
                        <div class="col-sm-9">
                            <b-form-input
                                ref="size"
                                v-model="form.size[1]"
                                max="440"
                                @change="priceСalculation()"
                            ></b-form-input>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="row" v-if="form.types_plotter_cutting == 0">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="diameter">{{ trans.get('admin.pages.tasks..form.diameter.title') }}</label>
                    <div class="col-sm-9">
                        <b-form-input
                            ref="diameter"
                            v-model="form.diameter"
                            @change="priceСalculation()"
                        ></b-form-input>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="paper_type">{{
                            trans.get('admin.pages.tasks..form.paper_type.title')
                        }}</label>
                    <div class="col-sm-9">
                        <b-form-select
                            ref="paper_type"
                            v-model="form.paper_type"
                            :options="options.paper_type"
                            text-field="name"
                            value-field="value"
                            disabled
                        ></b-form-select>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="paper_type_options"></label>
                    <div class="col-sm-9">
                        <b-form-select
                            ref="paper_type_option"
                            v-model="form.paper_type_option"
                            :options="options.paper_type_options[form.paper_type]"
                            text-field="name"
                            value-field="value"
                            @change="priceСalculation()"
                        ></b-form-select>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="lamination">{{
                            trans.get('admin.pages.tasks..form.lamination.title')
                        }}</label>
                    <div class="col-sm-9">
                        <b-form-select
                            ref="lamination"
                            v-model="form.lamination"
                            :options="options.lamination"
                            text-field="name"
                            value-field="value"
                            @change="priceСalculation()"
                        ></b-form-select>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="color">{{ trans.get('admin.pages.tasks..form.color.title') }}</label>
                    <div class="col-sm-9">
                        <b-form-select
                            ref="color"
                            v-model="form.color"
                            :options="options.color"
                            text-field="name"
                            value-field="value"
                            @change="priceСalculation()"
                            disabled
                        ></b-form-select>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="circulation">{{
                            trans.get('admin.pages.tasks..form.circulation.title')
                        }}</label>
                    <div class="col-sm-9">
                        <b-form-input
                            v-model="form.circulation"
                            @change="priceСalculation()"
                        ></b-form-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="price_circulation">{{
                            trans.get('admin.pages.tasks..form.price_circulation.title')
                        }}</label>
                    <div class="col-sm-9">
                        <b-form-input v-model="form.price_circulation" :disabled="true"></b-form-input>
                    </div>
                </div>
            </div>

            <template v-if="!only_calc">
                <div class="col-md-1">
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <b-form-checkbox
                                id="price_custom_check"
                                v-model="form.price_custom_check"
                                :unchecked-value="false"
                                :value="true"
                                class="mt-2"
                                name="price_custom_check"
                            />
                        </div>
                    </div>
                </div>
                <template v-if="form.price_custom_check">
                    <div class="col-md-2">
                        <div class="form-group row">
                            <div class="col-sm-12">
                                <b-form-input v-model="form.price"></b-form-input>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group row">
                            <div class="col-sm-12">
                                <b-form-input v-model="form.price_notes"></b-form-input>
                            </div>
                        </div>
                    </div>
                </template>
            </template>

        </div>


        <template v-if="!only_calc">

            <div class="row">

                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="note">{{ trans.get('admin.pages.tasks..form.note.title') }}</label>
                        <div class="col-sm-9">
                            <b-form-input v-model="form.note"></b-form-input>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">

                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label" for="performer_id">{{
                                trans.get('admin.pages.tasks..form.performer_id.title')
                            }}</label>
                        <div class="col-sm-9">
                            <vSelect
                                v-model="form.performer_id"
                                :filterable="false"
                                :options="options.admins"
                                :reduce="item => item.id"
                                label="name"
                                @search="onPerformer"
                            >
                                <template slot="no-options">
                                    {{ trans.get('admin.general.text.search') }}
                                </template>
                            </vSelect>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">

                <div class="col-md-12">
                    <div class="form-group">
                        <label class="col-form-label" for="taskUploadDropzone">{{ trans.get('admin.pages.tasks..title.upload') }}</label>
                        <vue-dropzone id="taskUploadDropzone" ref="taskUploadDropzone"
                                      :options="dropzoneOptions"></vue-dropzone>
                    </div>
                </div>

            </div>

            <b-button class="mt-3" variant="outline-success" @click="taskEdit(0)">{{
                    trans.get('admin.general.text.play')
                }}
            </b-button>
            <b-button class="mt-3" variant="outline-success" @click="taskEdit(1)">{{
                    trans.get('admin.general.text.save_calculation')
                }}
            </b-button>
        </template>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    name: "PlotterCutting",
    props: {
        name: {
            type: String
        },
        date: {
            type: String,
            default: null
        },
        manager_id: {
            type: Number
        },
        order_id: {
            type: Number
        },
        task_id: {
            type: Number,
            default: 0
        },
        department: {
            type: Number,
            default: 0
        },
        choice: {
            type: Number,
            default: 0
        },
        open: {
            type: Boolean,
            default: false
        },
        taskFormModal: {
            type: Boolean,
            default: false
        },
        unknown_task: {
            type: Boolean,
            default: false
        },
        only_calc: {
            type: Boolean,
            default: false
        },
    },

    components: {
        vueDropzone: vue2Dropzone
    },
    computed: {},

    data() {
        return {
            errors: [],
            form: {
                name: this.name,
                department: this.department,
                choice: this.choice,
                size: [210, 297],
                diameter: 0,

                types_plotter_cutting: 0,
                paper_type: 3,
                paper_type_option: 0,
                color: 0,
                lamination: 0,
                circulation: 0,
                price_circulation: 0,
                price_custom_check: false,
                price: null,
                price_notes: null,
                note: null,
                miscalculation: 0,
                performer_id: 12,
                type_calculator: 'PlotterCutting',
            },
            options: {
                admins: [],
                departments: [],
                departments_options: [],
                color: [],
                types_plotter_cutting: [],
                paper_type: [],
                paper_type_options: [],
                lamination: [],
            },
            dropzoneOptions: {
                url: this.route('admin.vue.task.upload', this.task_id),
                thumbnailWidth: 150,
                maxFilesize: 500,
                maxFiles: 10,
                method: 'POST',
            },
            form_id: null
        };
    },
    mounted() {
        if (this.open) {
            this.prepareComponent();
        }
    },

    methods: {
        prepareComponent() {
            this.getSetting('types_plotter_cutting')
            this.getSetting('paper_type')
            this.getSetting('color')
            this.getSetting('lamination')
            this.getAdmin(12)
            this.form_id = this.task_id
            if(this.form_id) {
                this.dropzoneOptions.url = this.route('admin.vue.task.upload', this.form_id)
            }
        },

        getTask(id) {
            axios.get(this.route('admin.vue.task.info'), {
                params: {
                    id: id,
                }
            })
                .then(response => {

                    this.form_id = response.data.data.id
                    this.form.name = response.data.data.name
                    this.form.price = response.data.data.price
                    this.form.price_notes = response.data.data.price_notes
                    this.form.price_custom_check = response.data.data.price_custom_check
                    this.form.note = response.data.data.note
                    this.form.miscalculation = response.data.data.miscalculation ?? 0
                    this.form.performer_id = response.data.data.performer_id ?? 12

                    this.form.size = response.data.data.parameters.size ?? [210, 297]
                    this.form.diameter = response.data.data.parameters.diameter ?? 0
                    this.form.types_plotter_cutting = response.data.data.parameters.types_plotter_cutting ?? 0
                    this.form.paper_type = response.data.data.parameters.paper_type ?? 3
                    this.form.paper_type_option = response.data.data.parameters.paper_type_option ?? 0
                    this.form.lamination = response.data.data.parameters.lamination ?? 0
                    this.form.color = response.data.data.parameters.color ?? 0
                    this.form.circulation = response.data.data.parameters.circulation ?? 0
                    this.form.price_circulation = response.data.data.parameters.price_circulation ?? 0

                    this.getAdmin(response.data.data.performer_id)
                });

        },

        priceСalculation() {
            this.form.name = this.name
            this.form.department = this.department
            this.form.choice = this.choice
            axios.post(this.route('admin.vue.calculation.info'), this.form)
                .then(response => {
                    this.form.price_circulation = response.data.data.price
                    if (!this.form.price_custom_check) {
                        this.form.price = response.data.data.price
                    }

                    if(this.form_id){
                        this.dropzoneOptions.url = this.route('admin.vue.task.upload', this.form_id)
                    }
                });
        },

        getSetting(name) {
            axios.get(this.route('admin.vue.setting.info'), {
                params: {
                    system_name: name,
                }
            })
                .then(response => {
                    if (name == 'paper_type') {
                        this.options.paper_type = response.data.data.paper_type
                        this.options.paper_type_options = response.data.data.paper_type_options
                    } else if (name == 'color') {
                        this.options.color = response.data.data.filter(function (obj) {
                            return obj.name !== '4+4' && obj.name !== '0+4' && obj.name !== '1+1';
                        });
                    } else {
                        this.options[name] = response.data.data
                    }
                });

        },

        taskEdit(miscalculation = 1) {
            this.form.name = this.name
            this.form.department = this.department
            this.form.choice = this.choice
            this.form.miscalculation = miscalculation
            axios.post(this.route('admin.vue.task.update'), Object.assign(this.form, {
                id: this.form_id,
                order_id: this.order_id
            }))
                .then(response => {

                    this.$emit('update:taskFormModal', false)

                    this.$bvToast.toast(this.trans.get('admin.general.text.success'), {
                        title: response.data.message,
                        variant: 'success',
                        solid: true
                    })
                })
                .catch(error => {
                    let errors = Object.values(error.response.data.errors);
                    errors = errors.flat();
                    this.errors = errors
                });
        },

        getAdmin(id) {
            if (id != null) {
                axios.get(this.route('admin.vue.admin.info'), {
                    params: {
                        id: id,
                    }
                })
                    .then(response => {
                        if (this.options.admins.find(item => item.id == id) === undefined) {
                            this.options.admins.push(response.data.data)
                        }
                    });
            }
        },
        onPerformer(search, loading) {
            loading(true);
            this.searchPerformer(loading, search, this);
        },
        searchPerformer: _.debounce((loading, search, vm) => {
            if (search) {
                axios.get(vm.route('admin.vue.admins.search'), {
                    params: {
                        q: search,
                    }
                })
                    .then(response => {
                        vm.options.admins = response.data.data
                        loading(false)
                    });
            }
            loading(false)
        }, 350),
    },


    watch: {
        'open': function (val) {
            if (val) {
                this.prepareComponent();
                if (this.form_id && this.unknown_task == false) {
                    this.getTask(this.form_id)
                }
            }
        },
    }

}
</script>

<style scoped>

</style>
